import { authApi } from './auth';
import { sharedApi } from './shared';
import { companyApi } from './company';
import { merchantApi } from './merchant';
import { riderApi } from './rider';
import { adminApi } from './admin';

export const api = { ...authApi, ...sharedApi, ...companyApi, ...merchantApi, ...riderApi, ...adminApi };

export { authApi, sharedApi, companyApi, merchantApi, riderApi, adminApi };
export { request, buildQueryString, API_BASE } from './request';